import {
  GraphComponent,
  GraphItemTypes,
  GraphViewerInputMode,
  INode,
  MouseWheelBehaviors,
  MoveViewportInputMode,
  Point,
  TimeSpan,
} from '@ardoq/yfiles';
import { MetaModelViewGraphNode } from '@ardoq/graph';

export const createGraphComponent = (
  container: HTMLDivElement,
  isThumbnailView = false
) => {
  const graphComponent = new GraphComponent(container);
  graphComponent.inputMode = createInputMode(isThumbnailView);
  graphComponent.minimumZoom = 0.1;
  if (isThumbnailView) {
    graphComponent.mouseWheelBehavior = MouseWheelBehaviors.NONE;
  }
  return graphComponent;
};

const createInputMode = (isThumbnailView: boolean) => {
  const result = new GraphViewerInputMode({
    toolTipItems: GraphItemTypes.NODE | GraphItemTypes.EDGE,
  });
  // Show a node's tooltip on hover, if it sets one.
  result.addEventListener('query-item-tool-tip', e => {
    if (e.handled || !(e.item instanceof INode)) {
      return;
    }
    const { tag } = e.item;
    const tooltip =
      tag instanceof MetaModelViewGraphNode ? tag.getTooltip() : undefined;
    if (tooltip) {
      e.toolTip = tooltip;
      e.handled = true;
    }
  });
  result.toolTipInputMode.toolTipLocationOffset = new Point(10, 10);
  // No API for "until the pointer leaves"; the default is a few seconds.
  result.toolTipInputMode.duration = TimeSpan.fromMilliseconds(999999);
  result.toolTipInputMode.delay = TimeSpan.fromMilliseconds(200);
  if (isThumbnailView) {
    result.moveViewportInputMode = new MoveViewportInputMode();
    result.moveViewportInputMode.enabled = false;
  }
  return result;
};
